export enum ELocalStorage {
  USER_DATA = 'data_user',
  USER_TOKEN = 'token_user',
}
